
import React, { useEffect, useState } from 'react';
import { generateBlogSitemap } from '@/utils/sitemapUtils';

/**
 * DynamicSitemap component for generating and serving XML sitemaps
 * Can be used for client-side rendering or pre-rendering
 */
const DynamicSitemap = () => {
  const [sitemap, setSitemap] = useState<string>('');

  useEffect(() => {
    const fetchSitemap = async () => {
      const sitemapXml = await generateBlogSitemap();
      setSitemap(sitemapXml);
      
      // Write sitemap to a blob for direct access
      if (typeof window !== 'undefined') {
        const blob = new Blob([sitemapXml], { type: 'application/xml' });
        const sitemapUrl = URL.createObjectURL(blob);
        
        // Log for debugging
        console.log('Blog sitemap generated', { url: sitemapUrl });
      }
    };

    fetchSitemap();
  }, []);

  return (
    <div>
      <div style={{ display: 'none' }}>
        <pre dangerouslySetInnerHTML={{ __html: sitemap }} />
      </div>
      {/* Visible content for users who might land on this page */}
      <div className="container mx-auto py-8 px-4">
        <h1 className="text-3xl font-bold mb-4">Astrem Blog Sitemap</h1>
        <p className="mb-4">This page contains the XML sitemap for our blog content.</p>
        <p>For the sitemap in XML format, please visit: <a href="/blog/sitemap.xml" className="text-blue-600 underline">blog/sitemap.xml</a></p>
      </div>
    </div>
  );
};

export default DynamicSitemap;
